<template>
<div>
  <b-row style="border-bottom:solid black 1px;text-align:center;">
    <b-col>
      <b> Current Moderators </b>
    </b-col>
  </b-row>
  <b-row>
    <b-col sm="1">
      <b-button size="sm"
        :disabled="!edit.email || !edit.name"
        variant="primary"
        @click="add_moderator"
        >
        Add
      </b-button>
    </b-col>
    <b-col>
      <b-input type="email"
         v-model="edit.email"
         placeholder="moderator email"
       >
      </b-input>
    </b-col>    
    <b-col>
      <b-input type="text"
         v-model="edit.name"
         placeholder="moderator name"
       >
      </b-input>
    </b-col>
    <b-col v-if="startend">
        <date-picker
           placeholder="Start time"
           v-model="modstartdate"
           type="datetime"
           :clearable="false"
           :not-before="Date.now()"
           lang="en"
           format="MM-DD-YYYY [at] hh:mm A"
           :time-picker-options="{
               start: '00:00',
               step: '00:15',
               end: '23:59'
           }"
       ></date-picker>
    </b-col>
    <b-col v-if="startend">
     <date-picker
         placeholder="End time"
         v-model="modenddate"
         type="datetime"
         :clearable="false"
         :not-before="Math.max(this.modstartdate,Date.now())"
         :input-attr="{ required: true }"
         lang="en"
         format="MM-DD-YYYY [at] hh:mm A"
         :time-picker-options="{
              start: '00:00',
              step: '00:15',
              end: '23:59'
         }"
     ></date-picker>
    </b-col>
  </b-row>

  <b-row>
    <b-col>
      <b-table
        striped
        hover
        show-empty
        stacked="sm"
        :items="ss.moderators"
        :fields="modFields"
        style="font-size:0.8rem"
        empty-text="There are no moderators."
        small>
        <template v-slot:cell(email)="m">
           {{ m.item.email }}
        </template>
        <template v-slot:cell(name)="m">
           {{ m.item.name }}
        </template>
        <template v-slot:cell(startep)="m">
           <span v-if="startend">
             {{ date_str(m.item.startep) }}
           </span>
        </template>
        <template v-slot:cell(endep)="m">
           <span v-if="startend">
             {{ date_str(m.item.endep) }}
           </span>
        </template>
        <template v-slot:cell(ctrl)="m">
           <b-button size="sm"
             class="float-right"
             variant="outline-danger"
             style="margin:0;padding:0 0.2rem;"
             @click="del_moderator(m.item)"
           >
             Del
           </b-button>
        </template>
      </b-table>
    </b-col>    
  </b-row>

  <b-row style="border-top:solid black 1px;text-align:center;">
    <b-col>
    </b-col>
  </b-row>

</div>
</template>

<script>

import utils from "../eventutils";
import DatePicker from "vue2-datepicker";

export default {
  name: "EvSessMod",
  props: ['ev','ss','startend','startep','endep'],
  components: {
    DatePicker
  },
  data() {
    return  {
       modFields: [
         {key: "email", label: ""},
         {key: "name", label: ""},
         {key: "startep", label: ""},
         {key: "endep", label: ""},         
         {key: "ctrl", label: ""},
       ],
       edit: {
         startep: this.startep,
         endep: this.endep,
       },
    };
  },
  computed: {
      modstartdate: {
        get() {
          return new Date(this.edit.startep);
        },
        set(value) {
          this.edit.startep = value.getTime();
        }
      },
      modenddate: {
        get() {
          return new Date(this.edit.endep);
        },
        set(value) {
          this.edit.endep = value.getTime();
        }
      },
  },
  methods: {
    add_moderator: function() {
       let vue = this;
       let mod = {};
       mod.id = utils.new_id(vue.ev);
       mod.email = vue.edit.email.toLowerCase();
       mod.name = vue.edit.name;
       if (vue.startend) {
         mod.startep = vue.edit.startep;
         mod.endep = vue.edit.endep;
       }
       vue.ss.moderators.push(mod);
       console.log(JSON.stringify(mod));

       vue.edit.email = "";
       vue.edit.name = "";
    },
    del_moderator: function(rem) {
       let vue = this;
       let index;
       rem.delete = true;
       vue.ss.moderators.forEach(function(m,i) {
         if (m.delete) { index = i; }
       });
       vue.ss.moderators.splice(index,1);

       window.wss_send(vx, "adm_event_add_attendee", {
         subd:window.vx.subd,
         event: {
            id: vue.ev.id,
         },
         att: {
           em: rem.email,
           access: [{
             id:""+vue.ss.kind+vue.ss.id+"mod"+rem.id,
             rem: true
           }],
          }
       });       
    },
    date_str: function(ep) {
      let opt = {month: 'short', day: 'numeric',
                 hour: '2-digit', minute: '2-digit' };
      return (new Date(ep)).toLocaleDateString("en-US", opt);
    }
  },
}
</script>

<style lang="scss" scoped>
</style>